import { colorsPalettes } from "@similarweb/styles";
import { Text } from "@similarweb/ui-components/foundations";

import { translate } from "app/filters/i18nFilter";

import {
    LowCreditsBannerContainer,
    LowCreditsButton,
    LowCreditsContent,
    LowCreditsDescription,
    TrialLowCreditsBannerContainer,
    TrialLowCreditsButton,
    TrialLowCreditsContent,
} from "./styles";

export type LowCreditsBannerProps = {
    titleKey: string;
    descriptionKey: string;
    isLoading?: boolean;
    buttonTextKey?: string;
    onClick?: VoidFunction;
    variant?: "compact" | "prominent" | "prominentCompact";
    isTrial?: boolean;
    isStacked?: boolean;
    isInline?: boolean;
};

export const LowCreditsBanner = ({
    titleKey,
    descriptionKey,
    onClick,
    buttonTextKey,
    isLoading = false,
    variant = "compact",
    isTrial = false,
    isStacked = false,
    isInline = false,
}: LowCreditsBannerProps) => {
    if (isTrial) {
        return (
            <TrialLowCreditsBannerContainer
                variant={variant}
                isStacked={isStacked}
                data-automation="low-credits-banner"
            >
                <TrialLowCreditsContent>
                    <Text
                        fontVariant="subtitle1"
                        color={colorsPalettes.indigo[300]}
                    >
                        {translate(titleKey)}
                    </Text>
                    <Text
                        fontVariant="body2"
                        color={colorsPalettes.indigo[300]}
                    >
                        {translate(descriptionKey)}
                    </Text>
                </TrialLowCreditsContent>
                {buttonTextKey && onClick ? (
                    <TrialLowCreditsButton
                        type="trial"
                        iconName="sparkles"
                        isLoading={isLoading}
                        onClick={onClick}
                    >
                        {translate(buttonTextKey)}
                    </TrialLowCreditsButton>
                ) : null}
            </TrialLowCreditsBannerContainer>
        );
    }

    const textColor = variant === "compact" ? colorsPalettes.carbon[400] : colorsPalettes.carbon[500];

    const content = (
        <>
            <Text
                fontVariant="subtitle1"
                color={textColor}
            >
                {translate(titleKey)}
            </Text>
            <LowCreditsDescription
                $isInline={isInline}
                fontVariant="body2"
                color={textColor}
            >
                {translate(descriptionKey)}
            </LowCreditsDescription>
        </>
    );

    const button =
        buttonTextKey && onClick ? (
            <LowCreditsButton
                type="outlined"
                isLoading={isLoading}
                onClick={onClick}
            >
                {translate(buttonTextKey)}
            </LowCreditsButton>
        ) : null;

    return (
        <LowCreditsBannerContainer
            variant={variant}
            $isInline={isInline}
            data-automation="low-credits-banner"
        >
            {isInline ? <LowCreditsContent>{content}</LowCreditsContent> : content}
            {button}
        </LowCreditsBannerContainer>
    );
};
